import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable({ providedIn: 'root' })
export class SafeSharingAnalytics extends AnalyticsBase {
  public readonly namespace = 'HeaderMenu';
  public readonly requireViewContext = false;

  public trackEnabled(origin: 'hotkey' | 'toggle') {
    this.track('SafeSharingEnabled', { origin });
  }
}
